/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { graphql } from 'gatsby';
import { handleRipple } from '../../../helpers/ripple';

import {
  StyledContentBlock,
  Button,
  StyledSection,
  Topwrapper,
  Title,
  Subtitle,
  Greywrapper,
  BlueText,
  Appwrapper,
  Apptext,
  Icon,
  HeroImage,
  HeroImageWrapper,
  ButtonText,
  Blackcircle,
} from './styled';
import QrCodeModal from '../QrCodeModal';

const HeroSection = () => {
  const { formatMessage } = useIntl();

  const appstoreSrc = formatMessage({
    id: 'home.heroSection.appstoreimage.src',
  });
  const appstoreAlt = formatMessage({
    id: 'home.heroSection.appstoreimage.alt',
  });
  const appstoreLink = formatMessage({
    id: 'home.heroSection.appstoreimage.link',
  });

  const playstoreSrc = formatMessage({
    id: 'home.heroSection.playstoreimage.src',
  });
  const playstoreAlt = formatMessage({
    id: 'home.heroSection.playstoreimage.alt',
  });
  const playstoreLink = formatMessage({
    id: 'home.heroSection.playstoreimage.link',
  });
  const heroSrC = formatMessage({
    id: 'home.heroSection.image.src',
  });
  const heroalt = formatMessage({
    id: 'home.heroSection.image.alt',
  });
  const Iconsrc = formatMessage({
    id: 'home.heroSection.Icon',
  });
  return (
    <StyledSection>
      <StyledContentBlock>
        <Topwrapper>
          <Title>
            <FormattedMessage id="home.heroSection.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.heroSection.subtitle" />
          </Subtitle>
          <Greywrapper>
            <BlueText>
              <FormattedMessage id="home.heroSection.wallettitle" />
            </BlueText>
            <QrCodeModal />
          </Greywrapper>
          <Appwrapper>
            <Apptext>
              <FormattedMessage id="home.heroSection.Buttontitle" />
            </Apptext>
            <a href={appstoreLink} target="_blank">
              <Icon src={appstoreSrc} alt={appstoreAlt} />
            </a>
            <a href={playstoreLink} target="_blank">
              <Icon src={playstoreSrc} alt={playstoreAlt} />
            </a>
          </Appwrapper>
          <Button
            onMouseEnter={handleRipple}
            onClick={() =>
              window.open(
                'https://bitcoincom.app.link/XcEjsS1zmBb?_p=c11433dc9a0a7af2e11e90f5ef',
                '_blank',
              )
            }
          >
            <ButtonText>
              <FormattedMessage id="home.heroSection.mobilebutton" />
            </ButtonText>
            <Blackcircle src={Iconsrc} />
          </Button>
        </Topwrapper>
        <HeroImageWrapper>
          <HeroImage src={heroSrC} alt={heroalt} />
        </HeroImageWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default HeroSection;

export const headerFragment = graphql`
  fragment HeroSection on Json {
    heroSection {
      title
      subtitle
      wallettitle
      Buttontitle
      mobilebutton
      mobilebuttonlink
      Icon
      image {
        src
        alt
      }
      playstoreimage {
        src
        alt
        link
      }
      appstoreimage {
        src
        alt
        link
      }
      qrimage {
        src
        alt
      }
    }
  }
`;
